import React, {Component} from 'react'
import {connect} from 'react-redux'
import PropTypes from "prop-types";

import {updateData} from '../../../routers/data'
import {updateSettings, fetchTravels, fetchLimits, fetchAvailableCalcs} from '../../../routers/settings'
import {plural, DatetoHtml, PassangersLine, VehiclesLine} from '../functions'

import PanelOrigin from './panelOrigin'
import PanelPassenger from './panelPassenger'
import PanelVehicles from './panelVehicles'
import PanelDepartureDate from './panelDepartureDate'
import PanelReturnDate from './panelReturnDate'

const TabButton = ({select, enabled, icon, title, subtitle, onclick, position, className}) => {
  let classValue = 'tab-button ' + className
  classValue += (select)?' tab-button-select': ''
  if (className === undefined){
    classValue += (!enabled)?' tab-button-disabled': ''
  } else {
    classValue += (!enabled)? ' ' + className + '-disabled': ''
  }

  return(
    <div className={classValue} onClick={(enabled)? onclick: undefined}>
      {(position === 'right')?
        <div className='title'>{title}<i className={icon} aria-hidden="true"/></div>
      :
        <div className='title'><i className={icon} aria-hidden="true"/>{title}</div>
      }
      <div className='subtitle'>{subtitle}</div>
    </div>
  )
}

const TabPanel = ({tab, index, panel}) => {
  return (
    <div className='tab-panel'>
      {(tab === index)?panel: undefined}
    </div>
  )
}

class tabs extends Component{
  static contextTypes = {
    router: PropTypes.object
  }

  constructor(props) {
    super(props);

    this.state = {
      returnDate: undefined
    };
  }

  handleDate = (value) => {
    this.setState({
      returnDate: value
    })
  }

  componentDidMount() {
    //Api requests
    this.props.fetchTravels();
    this.props.fetchLimits();
  }

  onClick = (index) => {

    const {tab} = this.props.settings
    if (index===5){
      window.scrollTo(0, 0)
      this.props.fetchAvailableCalcs(this.props.data ,this.props.settings)
      this.props.updateSettings({'tab': undefined})
    }else{
      if (tab === index){
        this.props.updateSettings({'tab': undefined})
      } else {
        //window.scrollTo(0, 300)
        this.props.updateSettings({'tab': index})
      }
    }
  }

  render(){
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].fastbooking.tabs
    const langPassengers = languages[langUrl].fastbooking.passengers
    const langVehicles = languages[langUrl].fastbooking.vehicles
    const langCalendar = languages[langUrl].fastbooking.calendar

    const {tab, travels} = this.props.settings
    const {travel, origin, destiny, nAdults, nTeens, nKids, nBabies, nCars, nMotorcycles,
           nVans, nBikes, nTowing, departuredate, returndate } = this.props.data.values
    const nPass = nAdults+ nTeens + nKids + nBabies
    const nVeh = nCars + nMotorcycles + nVans + nBikes + nTowing
    const passangers = nPass + ' ' + plural(nPass, langPlace.passengers)
    const vehicles = nVeh + ' ' + plural(nVeh, langPlace.vehicles)
    const mTab = (travel === 1 && tab === 4)? 3: tab

    let enableReturn = undefined
    let enableSearch = undefined
    const enablePass = (origin !== undefined && destiny !== undefined)
    const enableVeh = (enablePass && nPass > 0)

    if (travel===0) {
      enableReturn = (enableVeh && departuredate !== undefined)
      enableSearch = (enableReturn && returndate !== undefined)
    } else {
      enableReturn = (enableVeh && departuredate !== undefined)
      enableSearch = (enableVeh && departuredate !== undefined)
    }
    const originName = (destiny !== undefined)? travels[origin].name: ''
    const destinyName = (destiny !== undefined)? travels[origin].destinations[destiny].name: ''

    const classValue = (travel === 0)? 'col-md-6 col-sm-12 tab-container': 'col-md-12 tab-container'
    return(
      <div className='row tabs-component'>
        <div className='col-lg-12 col-md-12 col-sm-12 col-xs-12'>

          <div className='col-md-3 col-sm-12 tab-container'>
            <TabButton select={tab===0} enabled={true} icon='fa fa-ship icon' title={(travel===0)? langPlace.roundtrip: langPlace.going}
                      subtitle={(destiny !== undefined)? originName + ' - ' + destinyName: ''} onclick={() => this.onClick(0)} />
            <TabPanel tab={mTab} index={0} panel={<PanelOrigin enable={enablePass}/>} />
          </div>

          <div className='col-md-2 col-sm-12 tab-container'>
            <TabButton select={tab===1} enabled={enablePass} icon='fa fa-users icon' title={passangers}
                       subtitle={PassangersLine(this.props.data.values, langPassengers)} onclick={() => this.onClick(1)} />
            <TabPanel tab={mTab} index={1} panel={<PanelPassenger enable={enableVeh}/>} />
          </div>

          <div className='col-md-2 col-sm-12 tab-container'>
            <TabButton select={tab===2} enabled={enableVeh} icon='fa fa-car icon' title={vehicles}
                     subtitle={VehiclesLine(this.props.data.values, langVehicles)} onclick={() => this.onClick(2)} />
            <TabPanel tab={mTab} index={2} panel={<PanelVehicles enable={true}/>} />
          </div>

          <div className='col-md-3 col-sm-12'>
            <div className='row'>
              <div className={classValue}>
                <TabButton select={mTab===3} enabled={enableVeh} icon='fa fa-calendar icon' title={langPlace.going}
                       subtitle={DatetoHtml(departuredate, undefined, langCalendar)} onclick={() => this.onClick(3)} />
                <TabPanel tab={mTab} index={3} panel={<PanelDepartureDate enable={enableReturn} returnDate={this.state.returnDate}/>} />
              </div>
              {(travel === 0)?
                <div className='col-md-6 col-sm-12 tab-container'>
                  <TabButton select={tab===4} enabled={enableReturn} icon='fa fa-calendar icon' title={langPlace.return}
                        subtitle={DatetoHtml(returndate, undefined, langCalendar)} onclick={() => this.onClick(4)} />
                  <TabPanel tab={mTab} index={4} panel={<PanelReturnDate enable={enableSearch} test={this.handleDate}/>} />
                </div>
              : undefined}
            </div>
          </div>

          <div className='col-md-2 col-sm-12 tab-container'>
            <TabButton enabled={enableSearch} icon='fa fa-search' title={langPlace.find} position='right' className='tab-find'
                   onclick={() => this.onClick(5)} />
          </div>


        </div>
      </div>
    )
  }
}

export default connect(
  (state) => ({settings: state.settings, data: state.data}),
  {updateSettings, updateData, fetchTravels, fetchLimits, fetchAvailableCalcs}
)(tabs)



// WEBPACK FOOTER //
// ./src/shared/routes/components/fastbooking/tabs.js